/**
 * Huismerken.nl search relevantie-fix v9
 * - Pakt alle zoekformulieren
 * - Corrigeert ook direct de huidige search-URL
 * - Zet zoekterm exact:
 *   tuinbox -> "tuinbox"
 *   grote kast -> "grote kast"
 * - Houdt type=product en options[prefix]=none vast
 * - Verwijdert lege producttype-filter
 * - Voorkomt dat &quot; zichtbaar wordt in de zoekbalk
 */
(function () {
  if (window.hmExactSearchLoadedV9) return;
  window.hmExactSearchLoadedV9 = true;

  function decodeEntities(value) {
    var text = String(value || '');

    return text
      .replace(/&quot;/gi, '"')
      .replace(/&#34;/g, '"')
      .replace(/&#x22;/gi, '"')
      .replace(/&amp;quot;/gi, '"')
      .replace(/%26quot%3B/gi, '"')
      .replace(/%22/g, '"');
  }

  function clean(value) {
    return decodeEntities(value)
      .trim()
      .replace(/^"+|"+$/g, '')
      .replace(/\s+/g, ' ');
  }

  function isVariantGroup(value) {
    return /^\d+_[a-z]{2}$/i.test(clean(value));
  }

  function exact(value) {
    var term = clean(value);
    if (!term) return '';
    if (isVariantGroup(term)) return term;
    return '"' + term.replace(/"/g, '') + '"';
  }

  function isExact(value) {
    var term = decodeEntities(value).trim();
    return term.length >= 2 && term.charAt(0) === '"' && term.charAt(term.length - 1) === '"';
  }

  function displayTerm(value) {
    var term = clean(value);
    return /_nl$/i.test(term) ? '' : term;
  }

  function ensureHidden(form, name, value) {
    var input = form.querySelector('input[name="' + name.replace(/"/g, '\\"') + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }

    input.value = value;
    input.disabled = false;

    return input;
  }

  function isSearchForm(form) {
    if (!form || !form.matches || !form.matches('form')) return false;

    var action = form.getAttribute('action') || '';
    var hasSearchInput = !!form.querySelector('input[name="q"], input[type="search"]');

    return action.indexOf('/search') !== -1 || action === '/search' || hasSearchInput;
  }

  function prepareSearchForm(form) {
    if (!isSearchForm(form)) return;

    var qInput = form.querySelector('input[name="q"], input[type="search"]');
    if (!qInput) return;

    var term = clean(qInput.value);
    if (!term) return;

    qInput.value = exact(term);

    ensureHidden(form, 'type', 'product');
    ensureHidden(form, 'options[prefix]', isVariantGroup(term) ? 'last' : 'none');

    var productTypeInput = form.querySelector('[name="filter.p.product_type"]');
    if (productTypeInput && productTypeInput.value === '') {
      productTypeInput.disabled = true;
    }
  }

  function fixVisibleSearchInputs() {
    var params = new URLSearchParams(window.location.search || '');
    var q = params.get('q');

    document.querySelectorAll('input[name="q"], input[type="search"]').forEach(function (input) {
      if (!input || input.type === 'hidden') return;

      var source = input.value || q || '';
      var cleanValue = displayTerm(source);

      if (cleanValue || /_nl$/i.test(clean(source))) {
        input.value = cleanValue;
      }
    });
  }

  function fixCurrentSearchUrl() {
    if (window.location.pathname.indexOf('/search') === -1) {
      fixVisibleSearchInputs();
      return;
    }

    var url = new URL(window.location.href);
    var q = url.searchParams.get('q');
    if (!q) {
      fixVisibleSearchInputs();
      return;
    }

    var changed = false;

    var normalizedQuery = exact(q);
    if (q !== normalizedQuery) {
      url.searchParams.set('q', normalizedQuery);
      changed = true;
    }

    if (url.searchParams.get('type') !== 'product') {
      url.searchParams.set('type', 'product');
      changed = true;
    }

    var prefix = isVariantGroup(q) ? 'last' : 'none';
    if (url.searchParams.get('options[prefix]') !== prefix) {
      url.searchParams.set('options[prefix]', prefix);
      changed = true;
    }

    if (url.searchParams.get('filter.p.product_type') === '') {
      url.searchParams.delete('filter.p.product_type');
      changed = true;
    }

    if (changed) {
      window.location.replace(url.toString());
      return;
    }

    fixVisibleSearchInputs();
  }

  document.addEventListener(
    'submit',
    function (event) {
      prepareSearchForm(event.target);
    },
    true
  );

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest && event.target.closest('button, input[type="submit"]');
      if (!button) return;

      var form = button.form || button.closest('form');
      prepareSearchForm(form);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      if (!event.target.matches('input[name="q"], input[type="search"]')) return;

      var form = event.target.form || event.target.closest('form');
      prepareSearchForm(form);
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixCurrentSearchUrl);
  } else {
    fixCurrentSearchUrl();
  }

  window.addEventListener('pageshow', fixVisibleSearchInputs);
})();
